import React from 'react';
import './NoticeDetail.css';
import iconBack from '../../assets/images/icon-back.svg';

interface Notice {
  id: string;
  title: string;
  content: string;
  created_at: string;
  notification_type: string;
  image_url?: string;
}

interface NoticeDetailProps {
  notice: Notice;
  onBack: () => void;
  isEvent?: boolean;
}

const NoticeDetail: React.FC<NoticeDetailProps> = ({ notice, onBack, isEvent = false }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).replace(/\. /g, '.').replace(/\.$/, '');
  };

  return (
    <div className="notice-detail-container">
      <div className="notice-detail-header">
        <div className="notice-detail-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={onBack} />
          <h1 className="notice-detail-title">{isEvent ? '이벤트/프로모션' : '공지사항'}</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="notice-detail-content">
        <div className="notice-detail-header-info">
          <h2 className="notice-detail-main-title">{notice.title}</h2>
          <span className="notice-detail-date">{formatDate(notice.created_at)}</span>
        </div>
        <div className="notice-detail-divider"></div>
        <div className="notice-detail-body">
          {notice.image_url && (
            <img
              src={notice.image_url}
              alt={notice.title}
              className="notice-detail-image"
            />
          )}
          <p className="notice-detail-text">{notice.content}</p>
        </div>
      </div>
    </div>
  );
};

export default NoticeDetail;
